<template lang="pug">
.item-friend
  span.material-icons.remove(@click='onClickRemove(item)') cancel
  .img-avt
    img(:src='item.avatar' v-if='item.avatar')
    img(src='../../assets/images/faces/ic_AvatarDefault.svg' v-else)
  .fullname {{item.fullname || 'default'}}
  .list-link
    button.dropdown.relation-dropdown
      .dropdown-toggle(data-toggle="dropdown" )
        span(v-if="item.type === 1" v-text="'Bạn bè'")
        span(v-else-if="item.type === 2" v-text="'Bạn đồng hành'")
        span(v-else-if="item.type === 3" v-text="'Giáo viên'")
        span(v-else v-text="'Default'")
        .material-icons signal_cellular_4_bar
</template>

<script>
import MdNotification from '@/core/components/mdNotification'

export default {
  components: {
    MdNotification
  },
  props: {
    item: Object
  },
  data() {
    return {
      checkedToggle: false,
      status: 1,
      lstClasses: []
    }
  },
  mounted () {
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    onClickRemove(item) {
      this.$emit('onClickRemove', item)
    },
    numberWithCommas(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    }
  },
  created () {
  },
  apollo: {
  }
}
</script>
<style lang="scss">
.item-friend {position: relative; background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #EAEAEA;border-radius: 10px;
  span.remove{color: #f00;position: absolute;right: 5px;top: 5px;cursor: pointer;}
  .img-avt {width: 64px; height: 64px;display: block;margin: 8px auto;border-radius: 50%;overflow: hidden;
    img {width: 100%; height: auto;}
  }
  .fullname {font-size: 15px; text-align: center; padding: 0 5px;min-height: 50px;color: #333333;}
  .list-link {padding-bottom: 8px; text-align: center;
    button.relation-dropdown {background: #FBF4D2 0% 0% no-repeat padding-box; border-radius: 5px;color: #9F6A28; border: 1px solid #FBF4D2;height: 32px;width: calc(100% - 16px);font-size: 12px;;
      .dropdown-toggle { white-space: nowrap;text-align: left;
        span {font-size: 12px;color: #4B2D15;}
        .material-icons {transform: rotate(45deg); position: absolute; top: 7px;right: 5px; color: black;font-size: 10px;
        }
      }
    }
  }
}
@media (max-width: 1366px){
  .member-form{
    .box-content{
      .box-filter-member{
        .list-meber-selected{
          .box-custom-padding{
            .box-item-friend{width: 16.66666667%;}
          }
        }
      }
    }
  }
}
@media (max-width: 1024px){
  .member-form{
    .box-content{
      .box-filter-member{
        .list-meber-selected{
          .box-custom-padding{
            .box-item-friend{width: 20%;}
          }
        }
      }
    }
  }
}
@media (max-width: 991px){
  .member-form{
    .box-content{
      .box-filter-member{
        .list-meber-selected{
          .box-custom-padding{
            .box-item-friend{width: 20%;}
          }
        }
      }
    }
  }
}
@media (max-width: 767px){
  .member-form{
    .box-content{
      .box-filter-member{
        .list-meber-selected{
          .box-custom-padding{
            .box-item-friend{width: 20%;
              .item-friend{
                .list-link{
                  button.relation-dropdown{
                    .dropdown-toggle{
                      span{font-size: 11px;}
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
@media (max-width: 640px){
  .member-form{
    .box-content{
      .box-filter-member{
        .list-meber-selected{
          .box-custom-padding{
            .box-item-friend{width: 25%;}
          }
        }
      }
    }
  }
}
@media (max-width: 560px){
  .member-form{
    .box-content{
      .box-filter-member{
        .list-meber-selected{
          .box-custom-padding{
            .box-item-friend{width: 33.33%;}
          }
        }
      }
    }
  }
}
@media (max-width: 375px){
  .member-form{
    .box-content{
      .box-filter-member{
        .list-meber-selected{
          .box-custom-padding{
            .box-item-friend{width: 50%;}
          }
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// templateInfo.vue?7470ee32